<template>
  <span class="block text-shade-900 font-semibold first-letter:uppercase">
    {{ label }}
  </span>
  <Listbox v-model="selected">
    <ListboxButton
      class="ocus-visible:ring-primary-40 relative w-full py-2 cursor-default border border-shade-900 bg-white pr-12 pl-3 text-left outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400"
    >
      {{
        locale === 'fr' ? selected.label : selected.labelEn ?? selected.label
      }}</ListboxButton
    >
    <ListboxOptions
      class="absolute z-10 mt-1 max-h-60 w-2/3 overflow-auto border border-shade-900 bg-white text-base shadow-sm outline-none"
    >
      <ListboxOption
        v-for="option in options"
        :key="option.id"
        :value="option"
        v-slot="{ active, selected }"
      >
        <li
          :class="[
            selected ? ' bg-primary-alpha-100 text-primary-400' : '',
            active && !selected
              ? ' bg-shade-alpha-300 text-shade-900'
              : 'text-shade-900',
            'relative cursor-pointer select-none py-2.5 pr-2.5 pl-9',
          ]"
        >
          <span class="block truncate first-letter:uppercase">
            {{ locale === 'fr' ? option.label : option.labelEn }}
          </span>
          <span
            v-if="selected"
            class="absolute inset-y-0 left-0 flex items-center pl-3 text-primary-400"
          >
            <IconCheck class="h-4 w-4" aria-hidden="true" />
          </span>
        </li>
      </ListboxOption>
    </ListboxOptions>
  </Listbox>
</template>

<script setup>
import { ref } from 'vue'
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  model: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
})
const { locale } = useI18n()
const selected = ref(props.options[0])
watch(selected, (newSelected) => {
  if (props.data[props.model] !== newSelected.value) {
    props.data[props.model] = newSelected.value
  }
})
watch(
  () => props.data[props.model],
  (newValue) => {
    if (!newValue) {
      selected.value = props.options.find(({ value }) => !value)
    }
  }
)
</script>
<style></style>
